import { AnyAction } from 'redux';
import { AjaxError } from 'rxjs/ajax';
import { createSelector } from 'reselect';

import { AscendState } from './index';
import {
  CLEAR_ERRORS,
  ERROR_ADD_DEBT,
  ERROR_ADD_PAYMENT,
  ERROR_ADD_SETTLEMENT,
  ERROR_AGREEMENT,
  ERROR_CONTACT_SUBMIT,
  ERROR_EDIT_DEBT,
  ERROR_FETCH_ACCOUNTS,
  ERROR_FETCH_CONNECT_URL,
  ERROR_FETCH_TRANSACTIONS,
  ERROR_FOUND_DEBT,
  ERROR_FOUND_DEBTS,
  ERROR_HIDE_ACCOUNT,
  ERROR_REMOVE_MEMBER,
  ERROR_SHOW_ACCOUNT,
  ERROR_SUBMIT_BILLING,
  ERROR_SUBMIT_DETAILS,
  ERROR_USER_INFO,
  ERROR_PAYOFF_DEBT,
  ERROR_EDIT_PAYOFF_DEBT,
} from './actions';

// Reducer
export type ErrorState = {
  errors: AjaxError[];
};

const defaultState: ErrorState = {
  errors: [],
};
export const errorReducer = (state = defaultState, action: AnyAction): ErrorState => {
  switch (action.type) {
    case ERROR_FETCH_ACCOUNTS:
    case ERROR_HIDE_ACCOUNT:
    case ERROR_SHOW_ACCOUNT:
    case ERROR_FETCH_CONNECT_URL:
    case ERROR_FETCH_TRANSACTIONS:
    case ERROR_REMOVE_MEMBER:
    case ERROR_SUBMIT_BILLING:
    case ERROR_CONTACT_SUBMIT:
    case ERROR_FOUND_DEBTS:
    case ERROR_FOUND_DEBT:
    case ERROR_ADD_DEBT:
    case ERROR_ADD_PAYMENT:
    case ERROR_EDIT_DEBT:
    case ERROR_SUBMIT_DETAILS:
    case ERROR_ADD_SETTLEMENT:
    case ERROR_AGREEMENT:
    case ERROR_USER_INFO:
    case ERROR_PAYOFF_DEBT:
    case ERROR_EDIT_PAYOFF_DEBT: {
      const error = action.error;
      return { ...state, errors: [...state.errors, error] };
    }
    case CLEAR_ERRORS: {
      return { ...state, errors: [] };
    }
    default:
      return state;
  }
};

// Selectors
const errorsSelector = (state: AscendState) => state.error.errors;

export const errorMessagesSelector = createSelector(errorsSelector, (errors) =>
  errors.map((err) => (err.response ? err.response.error : err.message))
);
